<template>
    <div class="my-10 md:my-16 max-w-2xl mx-auto px-4">
        <div class="rounded-2xl border border-gray-200 bg-white shadow-custom-xl p-6 md:p-10 text-center space-y-5">
            <div class="mx-auto size-14 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
                <i class="icon-close text-2xl"></i>
            </div>

            <h1 class="text-2xl font-semibold text-slate-800">
                {{ title }}
            </h1>

            <p class="text-gray-600">
                {{ message }}
            </p>

            <div class="pt-2 flex items-center justify-center gap-3">
                <a href="/ponudbe" class="btn btn-primary btn-md">
                    {{ $t('Browse offers') }}
                </a>

                <a href="/" class="btn btn-secondary btn-md">
                    {{ $t('Back to home') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const title = computed(() => t('Your cart is empty.'))

const message = computed(() => t('Add a product to your cart to continue to checkout.'))
</script>
